import Abilities from './abilities';
import AddItemBtn from '../btn/addItemBtn';
import { BuildContext } from '../../Data/Context/buildData';
import React, { useState, useEffect, useContext } from 'react';
import Notes from '../notes/notes';
import BtnRounded from '../btn/btnRounded';
import { LanguageContext } from '../../Data/Context/languageContext';

const ItemRow = ({ id, title, itemType, itemCategory, modal, numberOfItems }) => {
    const { updateAbilitiesNotes, updatePersonalitiesNotes, updateHeldItemsNotes, updateHiddenSkillsNotes, updateGearNotes, buildDataFromDB, buildMode, clearAbilities, clearPersonalities, clearHeldItems, clearGear, clearHiddenSkills } = useContext(BuildContext);
    const [abilitiesNotes, setAbilitiesNotes] = useState(buildDataFromDB && buildDataFromDB.notes.abilities_notes ? buildDataFromDB.notes.abilities_notes : '');
    const [personalitiesNotes, setPersonalitiesNotes] = useState(buildDataFromDB && buildDataFromDB.notes.personalities_notes ? buildDataFromDB.notes.personalities_notes : '');
    const [heldItemsNotes, setHeldItemsNotes] = useState(buildDataFromDB && buildDataFromDB.notes.held_items_notes ? buildDataFromDB.notes.held_items_notes : '');
    const [gearNotes, setGearNotes] = useState(buildDataFromDB && buildDataFromDB.notes.gear_notes ? buildDataFromDB.notes.gear_notes : '');
    const [hiddenSkillNotes, setHiddenSkillNotes] = useState(buildDataFromDB && buildDataFromDB.notes.hidden_skills_notes ? buildDataFromDB.notes.hidden_skills_notes : '');
    const { t } = useContext(LanguageContext);

    useEffect(() => {
        updateAbilitiesNotes(abilitiesNotes)
        // eslint-disable-next-line
    }, [abilitiesNotes]);

    useEffect(() => {
        updatePersonalitiesNotes(personalitiesNotes)
        // eslint-disable-next-line
    }, [personalitiesNotes]);

    useEffect(() => {
        updateHeldItemsNotes(heldItemsNotes)
        // eslint-disable-next-line
    }, [heldItemsNotes]);

    useEffect(() => {
        updateGearNotes(gearNotes)
        // eslint-disable-next-line
    }, [gearNotes]);

    useEffect(() => {
        updateHiddenSkillsNotes(hiddenSkillNotes)
        // eslint-disable-next-line
    }, [hiddenSkillNotes]);

    return (
        <div id={id} className="row d-flex justify-content-center builder-body rounded purple-bk-lighter my-4 mx-2 global-shadow">
            <div className="col-12 d-flex justify-content-center align-items-center text-center items-title position-relative">
                <h2>{title}</h2>
            </div>

            {/* Abilities */}
            {itemType === 'ability' &&
                <>
                    <div className={`col-12 d-flex flex-wrap px-0 justify-content-center options text-center`}>
                        <Abilities itemType={itemType} modal={modal} numberOfItems={numberOfItems} itemCategory={itemCategory}></Abilities>
                    </div>

                    {(buildMode === 'building' || buildMode === 'editing') &&
                        <div className='text-center mb-4'>
                            <BtnRounded callFunction={clearAbilities} classes="mx-2">{t("clear")}</BtnRounded>
                        </div>
                    }

                    <div className='px-3'>
                        <Notes title={title} setNotes={setAbilitiesNotes} itemType={itemType} notes={buildDataFromDB ? buildDataFromDB.notes.abilities_notes : ''}>{buildDataFromDB ? buildDataFromDB.notes.abilities_notes : ''}</Notes>
                    </div>
                </>
            }

            {/* Personalities */}
            {itemType === 'personality' &&
                <>
                    <div className={`col-12 d-flex flex-wrap px-0 justify-content-center options text-center`}>
                        <AddItemBtn itemType={itemType} desc={itemCategory} modal={modal}></AddItemBtn>
                    </div>

                    {(buildMode === 'building' || buildMode === 'editing') &&
                        <div className='text-center mb-4'>
                            <BtnRounded callFunction={clearPersonalities} classes="mx-2">{t("clear")}</BtnRounded>
                        </div>
                    }

                    <div className='px-3'>
                        <Notes title={title} setNotes={setPersonalitiesNotes} itemType={itemType} notes={buildDataFromDB ? buildDataFromDB.notes.personalities_notes : ''}>{buildDataFromDB ? buildDataFromDB.notes.personalities_notes : ''}</Notes>
                    </div>
                </>
            }

            {/* Held Items */}
            {itemType === 'heldItem' &&
                <>
                    <div className={`col-12 d-flex flex-wrap px-0 justify-content-center options text-center`}>
                        <AddItemBtn itemType={itemType} desc={itemCategory} modal={modal}></AddItemBtn>
                    </div>

                    {(buildMode === 'building' || buildMode === 'editing') &&
                        <div className='text-center mb-4'>
                            <BtnRounded callFunction={clearHeldItems} classes="mx-2">{t("clear")}</BtnRounded>
                        </div>
                    }

                    <div className='px-3'>
                        <Notes title={title} setNotes={setHeldItemsNotes} itemType={itemType} notes={buildDataFromDB ? buildDataFromDB.notes.held_items_notes : ''}>{buildDataFromDB ? buildDataFromDB.notes.held_items_notes : ''}</Notes>
                    </div>
                </>
            }

            {/* Gear */}
            {itemType === 'gear' &&
                <>
                    <div className={`col-12 d-flex flex-wrap px-0 justify-content-center options text-center`}>
                        <AddItemBtn itemType={itemType} desc={itemCategory} modal={modal}></AddItemBtn>
                    </div>

                    {(buildMode === 'building' || buildMode === 'editing') &&
                        <div className='text-center mb-4'>
                            <BtnRounded callFunction={clearGear} classes="mx-2">{t("clear")}</BtnRounded>
                        </div>
                    }

                    <div className='px-3'>
                        <Notes title={title} setNotes={setGearNotes} itemType={itemType} notes={buildDataFromDB ? buildDataFromDB.notes.gear_notes : ''}>{buildDataFromDB ? buildDataFromDB.notes.gear_notes : ''}</Notes>
                    </div>
                </>
            }

            {/* Hidden Skills */}
            {itemType === 'hiddenSkill' &&
                <>
                    <div className={`col-12 d-flex flex-wrap px-0 justify-content-center options text-center hidden-skills-row`}>
                        <AddItemBtn itemType={itemType} desc={itemCategory} modal={modal}></AddItemBtn>
                    </div>

                    {(buildMode === 'building' || buildMode === 'editing') &&
                        <div className='text-center mb-4'>
                            <BtnRounded callFunction={clearHiddenSkills} classes="mx-2">{t("clear")}</BtnRounded>
                        </div>
                    }

                    <div className='px-3'>
                        <Notes title={title} setNotes={setHiddenSkillNotes} itemType={itemType} notes={buildDataFromDB ? buildDataFromDB.notes.hidden_skills_notes : ''}>{buildDataFromDB ? buildDataFromDB.notes.hidden_skills_notes : ''}</Notes>
                    </div>
                </>
            }
        </div>
    );
}
export default ItemRow;